module.exports = __webpack_public_path__ + "img/findings.acf1e2e5.png";